import { render } from "./QcmRouter.vue?vue&type=template&id=1b668792&scoped=true"
import script from "./QcmRouter.vue?vue&type=script&lang=js"
export * from "./QcmRouter.vue?vue&type=script&lang=js"

import "./QcmRouter.vue?vue&type=style&index=0&id=1b668792&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b668792"]])

export default __exports__